import { fetchJson2 } from 'helpers/api';

const handleErrorResponse = (response) => {
  switch (response.status) {
    case 401:
      return {
        success: false,
        authenticated: false,
      };
    case 403:
      return {
        success: false,
        authenticated: true,
        authorized: false,
      };
    case 500:
    case 504:
    default:
      return {
        success: false,
        message: 'Si è verificato un errore',
      };
  }
};

/** @deprecated use fetchPaymentTerms */
const fetchPaymentTermsV2 = async () => {
  const response = await fetch(`/api/payment-terms`);

  if (response.ok) {
    return {
      success: true,
      authenticated: true,
      authorized: true,
      data: await response.json(),
    };
  }
  return handleErrorResponse(response);
};

const fetchPaymentTerms = () => fetchJson2(`/api/payment-terms`);

export { fetchPaymentTerms, fetchPaymentTermsV2 };
